<template>
    <div class="tags_view">
        <!-- 面包屑导航栏 -->
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
            <el-breadcrumb-item v-for="item in Breadcrumb" :key="item.path" :to="item.path" class="title">
                {{ item.meta.title }}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
export default {
    name: "shopcarBreadCrumb",
    data() {
        return {
            Breadcrumb: [],

        }
    },
    created() {
        this.genBreadcrumb(this.$route);
    },
    watch: {
        $route: {
            handler(newVal) {
                this.genBreadcrumb(newVal);
            }
        },
    },
    methods: {
        genBreadcrumb(route) {
            // 获取含有title属性的路由。

            this.Breadcrumb = route.matched;
        },
    },
}
</script>

<style lang="less" scoped>
.tags_view {
    padding: 20px  0 20px 20px;
}

.tags_view .title {
    font-size: 16px !important;

}
</style>